export default __webpack_public_path__ + "8f9ce60830dcc79d2514af804d00a2b4.svg";